module.exports = __webpack_public_path__ + "static/media/lights222.40601953.jpg";